/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {declaration as ɵa} from './address.module';
export {AddressRoutes as ɵb} from './address.routing';